<template lang="pug" src="./custom-home-doctors.pug"></template>

<script>
import { textFadeUp } from '@/mixins'
import ModalSchedule from 'components/modal/modal-schedule/modal-schedule'

export default {
  data () {
    return {
      showModal: false
    }
  },
  props: ['props'],
  mixins: [textFadeUp],
  methods: {
    goToDrHingle () {
      this.$router.push('/about')
      setTimeout(() => {
        this.$scrollTo('#dr-hingle', { offset: -140 })
      }, 300)
    },
    goToDrPatel () {
      this.$router.push('/about')
      setTimeout(() => {
        this.$scrollTo('#dr-patel', { offset: -140 })
      }, 300)
    },
    goToSchedule () {
      this.$router.push('/get-started')
      setTimeout(() => {
        this.$scrollTo('#schedule-appointment', { offset: -70 })
      }, 300)
    },
    toggleModal () {
      this.showModal = !this.showModal
      this.showModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    closeScheduleModal () {
      this.showModal = false
      this.showModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  },
  components: {
    ModalSchedule
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-doctors.vue?03994c87